import {
    dateCompare,
    DetailItem,
    DetailSection,
    DOMAIN_TYPES,
    AppEnumHelper,
    formatName,
    SoNumber,
} from "@/Shared";
import { AuditViewModel } from "@/Shared/Logic/ViewModels/AuditViewModel";
import { AuditModel } from "@/Shared/Logic/Models/AuditModel";
import { AccessRightModel } from "@/Domains/Auth";
import { AgentTargetModel } from "../AgentTargetModel";

export interface AgentTargetVMParams {
    agentTarget: AgentTargetModel;
    accessRight: AccessRightModel;
    isDisplaying: boolean;
}

export class AgentTargetViewModel {

    public id: number;
    public model: AgentTargetModel;
 
    public year: number;
    public rentalTarget?: number;
    public salesTarget?: number;
    public otherProductsTarget?: number;
    public caTarget?: number;
    public mandatesTarget?: number;

    public audit!: AuditViewModel;
    public creationDate!: string;
    public creatorName!: string;
    public agent!: string;
    public isDeleted!: boolean;
    public cardClass!: string;

    public cardHeaderTitle!: string;

    public constructor(private params: AgentTargetVMParams) {
        const { agentTarget, isDisplaying } = this.params;

        this.model = agentTarget;
        this.id = agentTarget.id;
        
        this.year = agentTarget.year;
        this.rentalTarget = agentTarget.rentalTarget;
        this.salesTarget = agentTarget.salesTarget;
        this.otherProductsTarget = agentTarget.otherProductsTarget;
        this.caTarget =   agentTarget.caTarget;
        this.mandatesTarget = agentTarget.mandatesTarget;

        this.audit = new AuditViewModel(agentTarget as AuditModel);
        this.creationDate = this.audit.creationDate;
        this.creatorName = this.audit.creatorName;

        this.isDeleted = !!agentTarget.deletedAt;
        this.cardClass = isDisplaying ? 'active' : '';
       
        this.agent = formatName(agentTarget.agent?.person);

        this.cardHeaderTitle = this.title;
    }

    get title() {
        return `Objectif Agent N° ${this.id} - ${this.agent} (${this.year})`;
    }

    getAllSections = (): DetailSection[] => {
        const sections: DetailSection[] = [
            {
                sectionFn: this.getAgentTargetSection,
                legend: 'Caractéristiques Générales',
                type: 'box'
            },
            {
                sectionFn: this.getTargetsSection,
                legend: 'Objectifs Agent',
                type: 'box'
            },
        ];

        if (this.params.accessRight.canAudit(DOMAIN_TYPES.AgentTarget)) {
            sections.push({
                sectionFn: this.audit.getAuditTrail,
                legend: 'Traçabilité',
                type: 'box'
            });
        }

        return sections;
    }

    getAgentTargetSection = (): DetailItem[] => {
        return [
            { label: "N° Objectif Agent", value: String(this.id) },
            { label: "Agent", value: this.agent ?? "Inconnu" },
            { label: "Année", value: String(this.year) },
            { label: "Créée le", value: this.creationDate },
        ];
    }

    getTargetsSection = (): DetailItem[] => {
        return [
            { label: "Location cible", value: String(this.rentalTarget ?? 0) },
            { label: "Ventes cible", value: String(this.salesTarget ?? 0) },
            { label: "Autres produits cible", value: String(this.otherProductsTarget ?? 0) },
            { label: "CA cible", value: SoNumber.formatAmount(this.caTarget ?? 0) },
            { label: "Mandats cible", value: String(this.mandatesTarget ?? 0) },
            { label: "Créée le", value: this.creationDate },
        ];
    }

    compareTo(other: AgentTargetViewModel): number {
        return dateCompare(this.model.createdAt ?? "", other.model.createdAt ?? "");
    }
}
